import React, { Component } from 'react'
import { Popover, Modal, Input, Button, Upload, Icon, Spin } from 'antd'
import 'whatwg-fetch';
import rp from 'request-promise';

import { app, api, config } from '../../../../app'


import html2canvas from 'html2canvas';
// import { div } from '_echarts-gl@1.1.2@echarts-gl';
import { indexOf, methods } from 'underscore';



class ApplicationRegistration extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        let whiteInfo = {          //注册表内容
            // d1: '',
            d2: '',
            d3: '',
            d4: '',
            d5: '',
            d6: '',


        }
        let uploadImgList = []
        let whiteOK = false
        //添加文件组件使用
        if (props.fileInfo.length <= 0) {

        } else if (props.fileInfo[0].data != undefined) {

            if (props.fileInfo[0].data.d2 != undefined) {
                whiteInfo = props.fileInfo[0].data
                whiteOK = true
                this.props.reg_file_json(whiteInfo, 'data')
                if (props.fileInfo[0].img != undefined && props.fileInfo[0].img != '') {
                    uploadImgList = props.fileInfo[0].img.split(';;;')
                    this.props.reg_file_json(uploadImgList, 'img')
                }
            }
        }








        // console.log(props)

        this.state = {
            fileInfo: props.fileInfo,   //初始数据，一进入组件就请求获得



            // 注册申请表弹窗
            whiteModal: false,    //是否打开 注册申请表 编辑窗口
            whiteOK: whiteOK,  //是否已经提交过内容
            isModalVisible: false,  //是否打开 注册申请表 格式预览弹窗
            defaultImgList: [],


            whiteInfo: whiteInfo,

            imgModal: false,  //是否打开图片详情
            uploadImgList: uploadImgList,
            showMoadlImg: '',

        }
    }

    componentDidMount() {
        this.getDefaultImg()
        this.getExamineInfo()
        this.getApplyinfo()
    }



    componentWillReceiveProps(nextProps) {
        if (nextProps.applyinfo !== this.props.applyinfo) {
            if (this.props.apply != 1) {
                return
            }
            // 值发生改变下一步工作
            const applyinfo = app.getData('applyinfo');


            let uploadImgList = this.state.uploadImgList;
            // this.props.reg_file_json(whiteInfo, 'data')
            this.props.reg_file_json(applyinfo.file[0].data, 'data')

            uploadImgList = applyinfo.file[0].img.split(';;;')
            this.props.reg_file_json(uploadImgList, 'img')
            this.setState({
                uploadImgList,
                whiteInfo: applyinfo.file[0].data,
                whiteOK: true
            })
        }
        if (nextProps.examineInfo !== this.props.examineInfo) {
            // 值发生改变下一步工作
            if (this.props.examine != 1) {
                return
            }
            const examineInfo = app.getData('examineInfo');
            let uploadImgList = this.state.uploadImgList;
            uploadImgList = examineInfo.file[0].img.split(';;;')
            this.setState({
                uploadImgList
            })
        }

    }


    //对默认展示图片进行处理
    getDefaultImg = () => {
        if (this.props.fileInfo.length <= 0) {
            return
        }
        let defaultImgList = this.props.fileInfo[0].template_img.split(';;;')
        // console.log(defaultImgList)
        this.setState({
            defaultImgList
        })
    }

    getExamineInfo = () => {
        if (this.props.examine != 1) {
            return
        }
        const examineInfo = this.props.examineInfo;
        let uploadImgList = this.state.uploadImgList;
        uploadImgList = examineInfo.file[0].img.split(';;;')
        this.setState({
            uploadImgList
        })
    }

    getApplyinfo = () => {
        if (this.props.apply != 1) {
            return
        }
        const applyinfo = this.props.applyinfo;
        let uploadImgList = this.state.uploadImgList;
        // this.props.reg_file_json(whiteInfo, 'data')
        this.props.reg_file_json(applyinfo.file[0].data, 'data')

        uploadImgList = applyinfo.file[0].img.split(';;;')
        this.props.reg_file_json(uploadImgList, 'img')
        this.setState({
            uploadImgList,
            whiteInfo: applyinfo.file[0].data,
            whiteOK: true
        })
    }


    // {/* 存心救援队注册申请表 */}
    showModal = () => {
        this.setState({
            isModalVisible: true
        })
    };


    handleCancel = () => {
        this.setState({
            isModalVisible: false
        })
    };



    // {/* 存心救援队注册申请表 */}
    clickImg = (i) => {
        console.log(i.target.getAttribute('data-defaultImg'))
        this.setState({
            imgModal: true,
            showMoadlImg: i.target.getAttribute('data-img')
        })
    };

    deleImg = (i) => {
        // console.log(i)
        const { uploadImgList } = this.state;
        uploadImgList.splice(i, 1)
        // this.props.deleteImg_reg_file_json(i)
        this.props.reg_file_json(uploadImgList, 'img')
        this.setState({
            uploadImgList
        })
    };


    clickImgCencel = () => {
        this.setState({
            imgModal: false
        })
    };









    // 注册申请表弹窗
    white = () => {
        this.setState({
            whiteModal: true
        })
    }

    closeWhite = () => {
        this.setState({
            whiteModal: false
        })
    }


    upload = () => {

        const { whiteInfo } = this.state;

        console.log(whiteInfo)
        // if (whiteInfo.d1 == '') {
        //     app.alert('筹建团队名称未填写', 'error', '45%')
        //     return
        // }
        whiteInfo.d6 = whiteInfo.d4
        if (whiteInfo.d2 == '') {
            app.alert('申请人姓名未填写', 'error', '45%')
            return
        }


        if (whiteInfo.d3 == '') {
            app.alert('志愿队伍名称未填写', 'error', '45%')
            return
        }

        if (whiteInfo.d4 == '') {
            app.alert('筹建团队名称未填写', 'error', '45%')
            return
        }

        if (whiteInfo.d5 == '') {
            app.alert('品牌督导官名称未填写', 'error', '45%')
            return
        }

        if (whiteInfo.d6 == '') {
            app.alert('筹建团队名称未填写', 'error', '45%')
            return
        }

        this.props.reg_file_json(whiteInfo, 'data')



        //当完成所有数据验证后会将数据返回服务器，然在请求数据放到页面中，并允许让用户编辑内容
        this.setState({
            whiteModal: false,
            whiteOK: true
        })

    }



    _changeValue = (e) => {
        const { whiteInfo } = this.state;
        whiteInfo[e.target.name] = e.target.value.trim();
        this.setState({
            whiteInfo
        })
    }




    // 下载
    downLoad = (blobUrl) => {
        let that = this;
        let xhr = new XMLHttpRequest()
        
        xhr.open('POST', config.serverUrl + '/TeamPrep/getFilePdf', true)
        xhr.responseType = 'blob'
        let fd = new FormData();
        fd.append("key", 'reg');
        fd.append("file_data", JSON.stringify(this.state.whiteInfo));
        xhr.send(fd);
        xhr.onload = function () {
            if (this.status == 200) {
                let blob = this.response
                console.log(blob)
                that.downloadFile1(blob, 'pdf', '存心救援队注册申请表.pdf');
            }
        }
    }

    downloadFile1(data, type, fileName) {
        let blob = new Blob([data], { type: `application/${type};charset=utf-8` });
        console.log(123)
        // 获取heads中的filename文件名
        let downloadElement = document.createElement('a');
        // 创建下载的链接
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        // 下载后文件名
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        // 点击下载
        downloadElement.click();
        // 下载完成移除元素
        document.body.removeChild(downloadElement);
        // 释放掉blob对象
        window.URL.revokeObjectURL(href);
    }








    uploadImg = (info) => {
        if (info.file.status === 'uploading') {
            let flag = true
            this.props.uploadImgLoading(flag)
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            // this.setState({
            //     up_loading:true
            // })
            if (res.flag === 1) {
                app.alert(res.msg, 'success', '45%')
                // 将数据返回给父组件

                // let img = res.data.url;
                // this.props.reg_file_json(img, 'img')
                const { uploadImgList } = this.state;
                uploadImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.props.reg_file_json(uploadImgList, 'img')

                this.setState({
                    uploadImgList,

                }, () => {
                    let flag = false
                    this.props.uploadImgLoading(flag)
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }


    // {/* 存心救援队注册申请表end */}

    lastImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            //如果用户没有上传图片，那么点击图片预览的是模版图片
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = defaultImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            //如果用户上传了图片，那么点击图片预览的是上传图片
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = uploadImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }

    nextImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == defaultImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == defaultImgList.length - 1) {
                return
            } else {
                showMoadlImg = defaultImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == uploadImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == uploadImgList.length - 1) {
                return
            } else {
                showMoadlImg = uploadImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }




    // 页面渲染区
    render() {

        // console.log(this.state.defaultImgList)
        let { fileInfo, whiteInfo, defaultImgList, uploadImgList, up_loading } = this.state
        const content = (
            <div>
                <p>点击可预览模板</p>
            </div>
        )

        const imgList = uploadImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item} data-index={index}>预览</p>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' :
                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(index)}>删除</p>
                        }

                    </div>
                }>

                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

            )
        })



        const defaultImg = defaultImgList.map((item, index) => {
            return (



                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-defaultImg={true} data-index={index} data-img={item}>预览模板</p>
                    </div>
                }>
                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>
            )
        })

        return (

            <div >


                {/* 存心救援队注册申请表 */}
                <div style={{ width: 400, height: 200, borderWidth: 1, borderStyle: 'solid', borderColor: '#000', }}>
                    {/* 标题 */}
                    <p style={{ fontSize: 16, color: '#1890FF', paddingTop: 15, paddingLeft: 10 }}>
                        <Popover content={content}>
                            <span style={{ cursor: 'pointer' }} onClick={this.showModal}>《存心救援队注册申请表》</span>
                        </Popover>

                        <Modal title="存心救援队注册申请表" visible={this.state.isModalVisible} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.handleCancel}>
                            {
                                defaultImgList.map((item, index) => {
                                    return (

                                        <img style={{ width: 1150, marginRight: 5, borderBottom: 3, borderBottomStyle: 'solid', borderBottomColor: '#ddd' }} key={item} src={config.imgUrl + item} alt="" />

                                    )
                                })
                            }
                            {/* <img src={fileInfo.length < 1 ? '' : config.imgUrl + fileInfo[0].template_img} alt="" /> */}

                        </Modal>
                    </p>
                    {/* 标题end */}

                    {/* 资料框 */}
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '80%' }}>

                            <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3 }}>
                                {
                                    uploadImgList.length < 1
                                        ?
                                        defaultImg
                                        :
                                        imgList
                                }

                            </div>


                            <Modal title="存心救援队注册申请表" visible={this.state.imgModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel}>



                                <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                                    <div style={{ cursor: 'pointer' }} onClick={this.lastImg}>
                                        <Icon type="left" ></Icon> 上一张
                                    </div>
                                    <div style={{ cursor: 'pointer' }} onClick={this.nextImg}>
                                        下一张<Icon type="right" ></Icon>
                                    </div>
                                </p>
                                {

                                    <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000 }} />
                                }
                            </Modal>


                        </div>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' : !this.state.whiteOK
                                ?
                                <div >
                                    <div style={{ cursor: 'pointer', color: '#1890FF' }} onClick={this.white}>填写</div>
                                    <div style={{ marginTop: 5 }}>下载</div>
                                    <div style={{ marginTop: 5 }} >上传</div>
                                </div>
                                :
                                <div >
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.white}>编辑</div>
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.downLoad}>
                                        下载
                                        </div>


                                    {uploadImgList.length == 3
                                        ?
                                        <div style={{ marginTop: 5 }} >上传</div>
                                        :
                                        <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} >

                                            <Upload
                                                accept='image/jpeg, image/jpg, image/png'
                                                showUploadList={false}
                                                action={config.serverUrl + "/TeamApply/imageUpload"}
                                                name="image"
                                                onChange={this.uploadImg}
                                                style={{ color: '#1890FF' }}>
                                                上传</Upload>

                                        </div>}




                                </div>

                        }

                    </div>
                    {/* 资料框 */}

                </div>
                {/* 存心救援队注册申请表end */}

                <Modal title="存心救援队注册申请表" visible={this.state.whiteModal} width={1200} footer={null} onCancel={this.closeWhite}>

                    <div style={{ width: 1200, height: 1500, display: 'flex' }}>

                        <div style={{ width: 1200, paddingLeft: 40, paddingRight: 40, paddingTop: 70, paddingBottom: 120, height: 1350, fontSize: 22 }} id="JPGDOM">
                            <p style={{ textAlign: 'center', fontSize: 34, }}>
                                {/* <input type="text"
                                    onChange={this._changeValue}
                                    name="d1" value={whiteInfo.d1}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid', width: 300, }} /> */}

                            存心救援筹建申请</p>
                            <p>尊敬的存心救援品牌管理方：</p>
                            <p style={{ textIndent: '2em' }}>我,
                            <input type="text"
                                    onChange={this._changeValue}
                                    name="d2" value={whiteInfo.d2}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />

                            ，代表<input type="text"
                                    onChange={this._changeValue}
                                    name="d3" value={whiteInfo.d3}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />志愿团队，正式向存心救援品牌管理方提出<span style={{ color: 'red' }}>使用“存心救援”的标识及名称</span>筹建
                                    <input type="text"
                                    onChange={this._changeValue}
                                    name="d4" value={whiteInfo.d4}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />
                                    存心救援申请。</p>
                            <p style={{ textIndent: '2em' }}>经与存心救援
                            <input type="text"
                                    onChange={this._changeValue}
                                    name="d5" value={whiteInfo.d5}
                                    style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />品牌督导官接触，我们更深入的了解存心救援。存心救援是专门从事灾难救援及人道主义救助的非政府组织。自2007年成立以来，一直致力于为各种灾害、事故提供紧急救援，为受害者提供人道救助，也在普及防灾减灾知识。</p>
                            <p style={{ textIndent: '2em' }}>存心救援的工作重点包括自然灾害的紧急救援，日常事故的紧急救援，灾难的人道主义救助，灾后重建，防灾减灾的宣传，专业救援组织及人员的培训。</p>
                            <p style={{ textIndent: '2em' }}>存心救援遵循普世原则不隶属于任何政权和团体，完全独立于任何政治、经济和宗教势力之外，不分种族、宗教、性别、信仰、政治立场，为所有身处困境的人提供及时的救援与救助。全体成员严格遵循其专业规范，坚持人道救援的权利，严格保持中立和不偏不倚的立场。</p>
                            <p style={{ textIndent: '2em' }}>我们认真学习了并十分认可《<span style={{ color: 'red' }}>存心救援公约</span>》。我们将本着“人道、博爱、奉献”的志愿精神，遵守“少说多做，默默奉献，完善自我，善待他人”的整体队训，以积极进取、严格自律的方式，作为参与存心救援活动以及行动的准则。</p>
                            <p style={{ textIndent: '2em' }}>我们希望成立<input type="text"
                                onChange={this._changeValue}
                                name="d4" value={whiteInfo.d4}
                                style={{ outline: 'none', border: 0, borderBottom: 1, borderBottomColor: '#000', textAlign: 'center', borderStyle: 'solid' }} />存心救援筹备组，为本地乃至国内外的人道救援事业贡献自己的微薄之力。</p>

                            <p style={{ textIndent: '2em' }}><span style={{ color: 'red' }}>望存心救援品牌管理方授权使用“存心救援”标识名称、服饰旗帜并</span>批准为盼。</p>
                            <p style={{ textIndent: '2em' }}>致敬</p>
                            <p>敬礼！</p>
                            <p style={{ textIndent: '25em' }}>申请人：<span style={{ color: '#ccc', fontSize: 16 }}>签名加盖手指印</span></p>
                            <p style={{ textIndent: '25em' }}>申请日期：<span style={{ fontSize: 16 }}>________年________月________日</span></p>
                        </div>


                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.upload}>提交</Button>
                        <Button style={{ width: 200 }} onClick={this.closeWhite}>关闭</Button>
                    </div>



                </Modal>

            </div>
        )
    }
}



export default ApplicationRegistration



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/UploadInformationModal/ApplicationRegistration.jsx